import { returnsTeamDiscountByWeightSchema } from "@redotech/redo-fulfillment-rate-table-common/rate-table";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const saveTeamOverrideDiscountTable = {
  name: "saveTeamOverrideDiscountTable" as const,
  input: z.object({
    teamId: zExt.objectId(),
    discountTable: returnsTeamDiscountByWeightSchema,
  }),
  output: z.object({ discountTable: returnsTeamDiscountByWeightSchema }),
};
